import { useFormContext } from "react-hook-form";

import PhoneFields from "./fields/PhoneFields";
import OnboardingWizardStepFooter from "./OnboardingWizardStepFooter";
import OnboardingWizardStepHeader from "./OnboardingWizardStepHeader";
import type { WizardFormValues } from "./onboardingWizardForm";
import useOnboardingTracking from "./useOnboardingTracking";
import { useWizardMode } from "./WizardModeContext";
import { useOnboarding } from "~/hooks";

const OnboardingWizardStepPhone = () => {
	const { handleUpdate, setStep } = useOnboarding();
	const { mode } = useWizardMode();
	const { track } = useOnboardingTracking();
	const {
		trigger,
		getValues,
		formState: { isSubmitting },
	} = useFormContext<WizardFormValues>();

	const handleNext = async () => {
		if (!(await trigger("phoneNumber"))) return;
		const phoneNumber = getValues("phoneNumber");
		if (mode === "live") {
			await handleUpdate({ phoneNumber });
		}
		track("onboarding:step_completed", { provided_phone: !!phoneNumber });
		setStep(mode === "live" ? "complete" : "auth");
	};

	return (
		<div className="flex h-full min-h-0 flex-1 flex-col gap-4 phablet:gap-6">
			<OnboardingWizardStepHeader
				title="Get Updates via Text"
				subtitle="Optional. Get important updates via SMS."
			/>

			<div className="flex min-h-0 flex-1 flex-col gap-3 overflow-y-auto pr-1">
				<PhoneFields />
			</div>

			<OnboardingWizardStepFooter
				primary={{
					label: "Save & Continue",
					onClick: handleNext,
					disabled: isSubmitting,
				}}
				secondary={{
					label: "Skip",
					onClick: () => {
						track("onboarding:step_skipped");
						setStep(mode === "live" ? "complete" : "auth");
					},
				}}
			/>
		</div>
	);
};

export default OnboardingWizardStepPhone;
